import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPractitioners, fetchPractitioners } from '../../store/features/practitionerSlice';
import AtomicSpinner from 'atomic-spinner';
import { Button } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import PractitionerView from './practitionerView';
import styles from './practitioner.module.scss';
import Pagination from '../../models/Pagination';
import TableControl from '../../component/_shared/table/tableControl';
import calculateAge from '../../utils/globalFunctions';
import WithAuth from '../../component/_HighOrder/withAuth';
import WithNotify from '../../component/_HighOrder/withNotify';

const Provider = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [openFilter, setOpenFilter] = useState(false);
    const [practitioner, setPractitioner] = useState(null);
    const [pagination, setPagination] = useState({ ...(new Pagination(1, 10, '', 'ASC')) });
    const [filter, setFilter] = useState({
        active: true,
        address: '',
        'address_postalcode': '',
        communication: '',
        name: ''
    });
    const practitioners = useSelector((state) => state.practitioner.practitioners);

    useEffect(() => {
        getPractitioners();
    }, [pagination?.pageIndex, pagination?.pageSize, pagination?.sortCol, pagination?.sortType]);

    const getPractitioners = () => {
        setLoading(true);
        var tokenData = props.getValidProviderDirectoryToken({
            callback: (tokenData) => {
                dispatch(fetchPractitioners({
                    filter,
                    pagination,
                    token: tokenData.access_token,
                    callback: (response) => {
                        dispatch(setPractitioners(response.Data));
                        setPagination(new Pagination().set(pagination).setCount(response.Rows))
                        setLoading(false);
                    },
                    catch: (error) => {
                        setLoading(false);
                        dispatch(setPractitioners([]));
                        props.notify.error(error.message);
                    }
                }))
            },
            catch: (error) => {
                setLoading(false);
                dispatch(setPractitioners([]));
                props.notify.error(error.message);
            }
        });
    };

    const clearFilter = () => {
        setFilter({
            active: true,
            address: '',
            'address_postalcode': '',
            communication: '',
            name: ''
        });
    };

    const getFilter = () => {
        if (!openFilter)
            return <></>;

        return (
            <div className={styles.filterDiv}>
                <div className={styles.filterItem}>
                    <p>Active</p>
                    <select value={filter.active} onChange={(event) => setFilter({ ...filter, active: event.target.value })} style={{ fontSize: 12, height: 20 }}>
                        <option value={''}></option>;
                        <option value={true}>Active</option>
                        <option value={false}>Inactive</option>
                    </select>
                </div>
                <div className={styles.filterItem}>
                    <p>Address</p>
                    <input type='text' value={filter.address} onChange={(event) => setFilter({ ...filter, address: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Postal Code</p>
                    <input type='text' value={filter['address_postalcode']} onChange={(event) => setFilter({ ...filter, 'address_postalcode': event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Communication</p>
                    <input type='text' value={filter.communication} onChange={(event) => setFilter({ ...filter, communication: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <p>Name</p>
                    <input type='text' value={filter.name} onChange={(event) => setFilter({ ...filter, name: event.target.value })}></input>
                </div>
                <div className={styles.filterItem}>
                    <Button onClick={getPractitioners}>
                        Search
                    </Button>
                    <Button onClick={clearFilter}>
                        Clear
                    </Button>
                </div>
            </div>
        )
    };

    const viewDetails = (id) => {
        setPractitioner(practitioners.entry.filter((item) => item.resource.id.value === id)[0]);
    };

    const mountRows = () => {
        return practitioners.entry.map((item, index) => {
            return <tr key={index} className={(index % 2) > 0 ? styles.oddLine : styles.evenLine}>
                <td className={styles.tableColumn}>
                    <p>{item.resource.id.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.name?.map((item) => item.family.value + ', ' + item.given.map(name => name.value).join(' ')).join(' / ')}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.gender.value}</p>
                </td>
                <td className={styles.tableColumn}>
                    <p>{item.resource.birthDate ? calculateAge(item.resource.birthDate?.value) : ''}</p>
                </td>
                <td className={styles.tableColumn}>
                    <Button onClick={() => viewDetails(item.resource.id.value)}>
                        <MenuOpenIcon />
                    </Button>
                </td>
            </tr>
        });
    };

    const getList = () => {
        if (practitioner)
            return <></>;

        return (
            loading ? <div className={styles.atomicSpiner}><AtomicSpinner /></div>
                :
                <Fragment>
                    <Button color='primary' onClick={() => setOpenFilter(!openFilter)}>
                        <FilterListIcon />
                        Filter
                    </Button>
                    {getFilter()}
                    <br />
                    <br />
                    <table className={styles.practitionerTable}>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Age</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                practitioners && practitioners.entry?.length > 0 ?
                                    mountRows()
                                    :
                                    <tr>
                                        <td colSpan='3'>
                                            <p>No Results</p>
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                    {practitioners && practitioners.entry?.length > 0 ? <TableControl pagination={pagination} setPagination={setPagination} /> : <></>}
                </Fragment>
        );
    };

    const getView = () => {
        if (practitioner)
            return (
                <div>
                    <button className={styles.filterBtn} onClick={getBack}>Back</button>
                    <PractitionerView practitioner={practitioner}></PractitionerView>
                </div>
            );

        return <></>;
    };

    const getBack = () => {
        setPractitioner(null);
    };

    return (
        <div className={styles.practitionerDiv}>
            <h2>Provider Page</h2>

            {getView()}

            {getList()}
        </div>
    );
};

export default WithNotify(WithAuth(Provider));